import angular from 'angular';
import DeliveryOptionsController from './delivery-options.controller';
import CartService from '../../../app/cart/cart.service';
export default angular.module('directives.deliveryOptions', [])
    .service('CartService', CartService)
    .component('deliveryOptions', {
    template: require('./delivery-options.html'),
    controller: DeliveryOptionsController,
    bindings: {
        showHeatSensitiveWarning: '<',
        selectedAddress: '<',
        onShippingOptionSelect: '&'
    }
})
    .filter('replaceSpaces', [function () {
        return function (string) {
            if (!angular.isString(string))
                return string;
            return string.replace(/[\s](?!$)/g, '_');
        };
    }])
    .name;
//# sourceMappingURL=index.js.map